module.exports = __webpack_public_path__ + "static/media/ChangeLang.4796b0e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ChangeLang.png
// module id = 615
// module chunks = 0